"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var appShape_1 = __importDefault(require("../../appShape"));
var sc = __importStar(require("./AppRow.styles"));
var propTypes = {
    app: prop_types_1.default.shape(appShape_1.default).isRequired,
    shouldOpenNewTab: prop_types_1.default.bool,
};
function AppRow(props) {
    var app = props.app, shouldOpenNewTab = props.shouldOpenNewTab;
    var Icon = app.icon;
    return (react_1.default.createElement(sc.AppRow, { "data-sri-anchor": "app-switcher-section.app", key: app.title, href: app.link, "data-testid": "appRow", target: shouldOpenNewTab ? '_blank' : '_self', rel: shouldOpenNewTab ? 'noopener noreferrer' : undefined },
        react_1.default.createElement(Icon, { color: app.iconColor, size: "20px" }),
        app.title));
}
AppRow.propTypes = propTypes;
exports.default = AppRow;
//# sourceMappingURL=AppRow.js.map